import { FormProvider, useForm } from "react-hook-form"
import { MaintenanceType, maintenanceValidation } from "../../utils"
import { FormMaintenance } from "../FormSection"
import { defaultValueMaintenance } from "../../utils/vars"
import { yupResolver } from "@hookform/resolvers/yup"
import { useContext } from "react"
import { FormDataContext } from "../../context"
import { useApi } from "utils"
import toast from "react-hot-toast"

export function TabMainteance() {
    const api = useApi()

    const { dataAsset, refecth } = useContext(FormDataContext)

    const method = useForm<MaintenanceType>({
        defaultValues: defaultValueMaintenance(dataAsset ?? {}),
        resolver: yupResolver(maintenanceValidation)
    })



    const onSubmit = (data: MaintenanceType) => {

        const finalData = { ...data, asset_id: dataAsset?.asset_id }
        const formData = new FormData()

        Object.entries(finalData).forEach(([key, value]) => {
            formData.append(key, String(value));
        })

        const url = dataAsset?.asset_maintenance_id
            ? `/assetdepre/update_asset_maintenance?asset_maintenance_id=${dataAsset?.asset_maintenance_id}`
            : "/assetdepre/update_asset_maintenance";

        return new Promise<void>((resolve) => {
            toast.promise(
                api.put(url, formData),

                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message ?? err.response.message
                }
            ).then((res) => {
                refecth()

                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;

            }).catch(() => { }).finally(resolve)
        })
    }

    return (
        <FormProvider {...method}>
            <FormMaintenance onSubmit={method.handleSubmit(onSubmit)} />
        </FormProvider>
    )
}